
import AdvancedCodingExerciseInfoAbs from "#infra/info/AdvancedCodingExerciseInfoAbs";
import { EX_TYPE } from "../../../../../../../infra/info/ExerciseInfoAbs";

export default class ExerciseInfo extends AdvancedCodingExerciseInfoAbs {

  public getType(): EX_TYPE {
    return EX_TYPE.EX_TYPE_CODING_ADVANCED;
  }

  public getRepoName(): string {
    return "cif-ex-bs";
  }

  public getExerciseName(): string {
    return "booking-system";
  }

}
